export default __webpack_public_path__ + "fd3a44c9f7d7bc64e442c21294d68219.svg";